import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  inputMask: {
    position: 'relative',
    '& .shown-input': {
      whiteSpace: 'pre',
      '& .part': {
        overflow: 'visible',
        position: 'relative',
        '&.dynamic': {
          minWidth: '0.55em',
        },
      },
    },
    '& .caret': {
      display: 'none',
      position: 'absolute',
      right: '-2px',
      zIndex: 999,
    },
    '& .hidden-input': {
      position: 'absolute',
      opacity: 0,
      zIndex: 2,
      height: '100%',
      width: '100%',
      right: 0,
      '&:focus ~ .shown-input .caret': {
        display: 'inline-block',
        animation: '$blink 0.8s infinite',
        animationTimingFunction: 'cubic-bezier(1, -1, 0, 1)',
        overflow: 'visible',
      },
    },
  },
  '@keyframes blink': {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
});

export default useStyle;
